<template>
  <modal-template
    ref="modal"
    class-header="d-none"
    title=""
    type-modal="approved_quotation_modal"
  >
    <div class="modal-content__main">
      <d-form-row class="text-center">
        <h2 class="w-100 d-inline">Parabéns {{ model.created_user.name }}!</h2>
        <h5 class="w-100 d-inline">você acaba de marcar um gol!</h5>
        <img
          id="main-logo"
          class="d-inline m-auto"
          src="@/assets/images/gol.gif"
          alt="Gol em gif"
        />
      </d-form-row>
      <!-- <pre>{{model}}</pre> -->
    </div>

    <div slot="actions" class="modal-content__control d-flex justify-content-center w-100 m-0">
      <d-button
        type="button"
        @click="close()"
        class="btn btn-sm btn-success"
      >Fechar</d-button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import ModalTemplate from '_shared/Modal.vue';

export default {
  name: 'approved-modal',
  components: {
    ModalTemplate,
  },
  props: {
    model: {
      type: Object,
      default: null,
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
    ]),
    close() {
      this.setToggle({ type: 'approved_quotation_modal', bool: false });
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-content__control {
  display: flex;
  justify-content: flex-end;
}
</style>
